module.exports = __webpack_public_path__ + "img/24.18108997.png";